// extracted by mini-css-extract-plugin
export default {"trigger":"Pwd87IanR1UOJhaHPGiv"};